import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFileInfo } from './index';
import { checkFileExtension, checkFileIsImage, checkFileSize, checkFileWidthHeight, uploadFile as _uploadFile } from './upload';
export default {
  name: 'UpLoadIndex',
  props: {
    tempurl: {
      type: String,
      default: ''
    },
    allowType: {
      type: String,
      default: ''
    },
    linkUrl: {
      type: Object,
      default: Object
    },
    onlyImg: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canDel: {
      type: Boolean,
      default: false
    },
    deletePadding: {
      type: Boolean,
      default: false
    },
    //  值saleCallLog通话记录上传展示上传列表支持图片pdf
    source: {
      type: String,
      default: ''
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null
    },
    currentFileCount: {
      type: Number,
      default: 0
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    imgWidth: {
      // 用于校验图片尺寸
      type: Number | String,
      default: function _default() {
        return '';
      }
    },
    imgHeight: {
      // 用于校验图片尺寸
      type: Number | String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      fileTypeList: [],
      sizeLimit: 0,
      loadingInstance: null
    };
  },
  computed: {
    img_url: function img_url() {
      return this.tempurl;
    }
  },
  // mounted() {
  //   this.img_url = this.tempurl
  // },
  created: function created() {
    var _this$uploadInfo = this.uploadInfo,
      file_allow_extensions = _this$uploadInfo.file_allow_extensions,
      file_size_limit = _this$uploadInfo.file_size_limit;
    if (file_allow_extensions && file_size_limit) {
      this.fileTypeList = file_allow_extensions;
      this.sizeLimit = file_size_limit;
      return;
    }
    this.getUploadInfo();
  },
  methods: {
    handleExceed: function handleExceed(files, fileList) {
      console.log(files, fileList, this.limit, files.length > this.limit, 125);
      if (files.length > this.limit) {
        // 这里是活动运营上传图片的提示
        this.$message.error("\u6700\u591A\u4E0D\u8D85\u8FC7".concat(this.limit, "\u5F20"));
      }
      this.$refs.upload.clearFiles();
    },
    deletePic: function deletePic() {
      this.$emit('onDelete');
    },
    uploadBanner: function uploadBanner() {
      this.$refs['upload'].$refs['upload-inner'].handleClick();
    },
    // 获取图片上传类型等
    getUploadInfo: function getUploadInfo() {
      var _this = this;
      getFileInfo(this.linkUrl).then(function (res) {
        _this.fileTypeList = res.data.file_allow_extensions;
        _this.sizeLimit = res.data.file_size_limit;
        _this.$emit('getDefaultCheckInfo', {
          fileTypeList: _this.fileTypeList,
          sizeLimit: _this.sizeLimit
        });
      });
    },
    //获取文件上传规则
    // async getFileRule() {
    // 	const res = await getFileRule()
    // 	if (res.status === 200) {
    // 		this.fileTypeList = res.data.file_allow_extensions
    // 		this.sizeLimit = res.data.file_size_limit
    // 		this.$emit('getDefaultCheckInfo', {
    // 			fileTypeList: this.fileTypeList,
    // 			sizeLimit: this.sizeLimit,
    // 		})
    // 	}
    // },
    // 上传前的函数 //上传前对图片类型和大小进行判断
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var extensions, size, msg, msgError, checkRes, _msgError;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(_this2.limit && _this2.currentFileCount >= _this2.limit)) {
                _context.n = 1;
                break;
              }
              _this2.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(_this2.limit, "\u4E2A\u6587\u4EF6"));
              return _context.a(2, Promise.reject());
            case 1:
              extensions = _this2.fileTypeList;
              size = _this2.sizeLimit / 1024;
              if (!(_this2.onlyImg && !checkFileIsImage(file) || !checkFileExtension(file, extensions) && extensions.length)) {
                _context.n = 2;
                break;
              }
              msg = '只能上传' + extensions.toString();
              _this2.$message.error(msg);
              return _context.a(2, Promise.reject());
            case 2:
              if (checkFileSize(file, size)) {
                _context.n = 3;
                break;
              }
              msgError = _this2.source == 'file' ? "\u8BF7\u4E0A\u4F20".concat(size, "M\u4EE5\u5185\u7684\u6587\u4EF6") : "\u8BF7\u4E0A\u4F20".concat(size, "M\u4EE5\u5185\u7684\u56FE\u7247");
              _this2.$message.error(msgError);
              return _context.a(2, Promise.reject());
            case 3:
              if (!(_this2.imgWidth && _this2.imgHeight)) {
                _context.n = 5;
                break;
              }
              _context.n = 4;
              return checkFileWidthHeight(file, _this2.imgWidth, _this2.imgHeight);
            case 4:
              checkRes = _context.v;
              if (checkRes) {
                _context.n = 5;
                break;
              }
              _msgError = "\u8BF7\u4E0A\u4F20".concat(_this2.imgWidth, "*").concat(_this2.imgHeight, "\u7684\u56FE\u7247");
              _this2.$message.error(_msgError);
              return _context.a(2, Promise.reject());
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    uploadFile: function uploadFile(param) {
      var _this3 = this;
      var file = param.file;
      this.title = file.name;
      this.loadingInstance = this.$loading({
        lock: true,
        text: '上传中 0%',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var onProgress = function onProgress(progress) {
        if (_this3.loadingInstance) {
          _this3.loadingInstance.text = "\u4E0A\u4F20\u4E2D ".concat(progress, "%\uFF0C\u8BF7\u7A0D\u7B49\uFF01");
        }
      };
      _uploadFile(file, onProgress, this.linkUrl).then(function (response) {
        if (response.status === 200) {
          // this.img_url = URL.createObjectURL(file)
          // console.log(param)
          _this3.loadingInstance.close();
          console.log(response);
          _this3.$emit('emitUploadFile', response.config.key, URL.createObjectURL(file), param.file.name, file.uid, file.size);
        } else {
          var error = new Error('后台错误信息：' + response.msg);
          return Promise.reject(error);
        }
      }).catch(function (error) {
        console.log(error);
        if (_this3.loadingInstance) {
          _this3.loadingInstance.close();
        }
        _this3.$notify.error({
          title: '错误',
          message: '上传失败！',
          duration: _this3.notifyTime
        });
      });
    },
    handleRemove: function handleRemove(file) {
      this.$emit('handleRemove', file);
    },
    // 点击已上传文件下载
    handlePreview: function handlePreview(file) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var target, url, response, blob, downloadUrl, a, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              // el-upload 内部新增的上传项没有 url，从 fileList 中按 uid 匹配
              target = _this4.fileList.find(function (item) {
                return item.uid === file.uid;
              }) || file;
              url = target.url;
              if (url) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return fetch(url);
            case 2:
              response = _context2.v;
              _context2.n = 3;
              return response.blob();
            case 3:
              blob = _context2.v;
              downloadUrl = URL.createObjectURL(blob);
              a = document.createElement('a');
              a.href = downloadUrl;
              a.download = target.name || file.name || '';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(downloadUrl);
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              // 跨域等场景下载失败时回退为新窗口打开
              window.open(url, '_blank');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 4]]);
      }))();
    },
    handleChange: function handleChange(file, fileList) {
      this.$emit('getUploadNum', fileList.length);
    }
  }
};